<template>
  <!-- <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 122 146"
    style="enable-background: new 0 0 122 146"
    xml:space="preserve"
  > -->
  <svg
    x="0px"
    y="0px"
    viewBox="0 0 122 95"
    style="enable-background: new 0 0 122 95"
    xml:space="preserve"
  >
    <g></g>
    <g></g>
    <g class="st0"></g>
    <g>
      <g>
        <g>
          <!-- <g class="st3">
            <path
              class="st4"
              d="M5.168,113.103c-1.479,0-2.24,0.04-3.359,0.2v-4.319c1.08,0.2,2.039,0.24,3.6,0.24h5.919
                    c1.52,0,2.439-0.04,3.559-0.24v4.279c-1.039-0.12-1.879-0.16-3.279-0.16h-1.039v7.839h1.199c1.16,0,1.72-0.04,2.56-0.16v4.04
                    c-0.92-0.12-1.64-0.16-2.56-0.16h-1.199v7.398c1.319-0.56,2.079-0.88,4.358-1.959v4.079c-3.359,1.84-6.038,2.959-10.598,4.559
                    c-1.12,0.4-1.479,0.521-2.08,0.8l-1.119-4.599c1.079-0.16,2.919-0.64,5.238-1.4v-8.878H4.888c-1.08,0-1.88,0.04-2.72,0.2v-4.08
                    c0.92,0.12,1.561,0.16,2.8,0.16h1.399v-7.839H5.168z M19.726,131.14c-1.44,0-2.12,0.04-3.76,0.12
                    c0.08-1.319,0.12-2.439,0.12-4.039v-14.958c0-2.159-0.04-2.879-0.12-4.039c1.04,0.12,1.84,0.16,3.88,0.16h12.237
                    c1.88,0,2.76-0.04,3.84-0.16c-0.12,1.04-0.16,2.08-0.16,4.039v14.718c0,1.76,0.04,2.96,0.16,4.319
                    c-0.84-0.08-1.92-0.16-2.359-0.16h-2.92v7.959c0,0.6,0.2,0.68,1.88,0.68c1.08,0,1.64-0.12,1.84-0.439
                    c0.279-0.36,0.479-2.28,0.52-4.8c1.16,0.681,2.399,1.2,3.72,1.6c-0.36,4.319-0.641,5.6-1.44,6.399
                    c-0.84,0.84-2.279,1.12-5.398,1.12c-2.88,0-4.04-0.2-4.72-0.8c-0.52-0.44-0.6-0.761-0.6-2.24v-9.479h-1.96
                    c-0.399,2.439-0.56,3-1.04,4.239c-1.079,2.72-2.879,4.96-5.398,6.64c-1.56,1.039-2.96,1.68-5.6,2.52
                    c-0.56-1.32-1.119-2.16-2.52-3.68c2.12-0.48,3.239-0.88,4.6-1.6c3.56-1.92,5.319-4.439,5.759-8.119H19.726z M20.205,114.862
                    h11.358v-2.719H20.205V114.862z M20.205,121.062h11.358v-2.72H20.205V121.062z M20.205,127.421h11.358v-2.88H20.205V127.421z"
            />
            <path
              class="st4"
              d="M75.003,112.064c2.16,0,3.72-0.08,4.8-0.24v4.679c-1.28-0.159-2.8-0.239-4.8-0.239H58.526
                    c-1.68,3.359-3.12,5.679-5.239,8.358v14.718c0,2.159,0.04,3.52,0.199,4.639h-4.879c0.16-1.279,0.24-2.56,0.24-4.639v-9.879
                    c-1.52,1.48-1.8,1.72-3.04,2.68c-0.84-1.6-1.68-2.72-2.999-3.959c2.399-1.76,4.319-3.399,6.039-5.279
                    c-0.08-1.56-0.08-1.56-0.16-2.239h2.04c1.159-1.48,1.999-2.8,2.879-4.399h-4.879c-2,0-3.56,0.08-4.799,0.239v-4.679
                    c1.079,0.16,2.64,0.24,4.799,0.24h6.879c0.88-2.2,1.399-3.88,1.6-5.319l4.959,0.96c-0.199,0.439-0.279,0.6-0.64,1.6
                    c-0.32,0.96-0.68,1.88-1.04,2.76H75.003z M73.684,124.901c1.999,0,3.119-0.08,4.279-0.24v4.52c-1.2-0.16-2.439-0.2-4.279-0.2
                    h-4.999v9.398h6.358c2.12,0,3.319-0.08,4.439-0.24v4.6c-1.56-0.16-2.72-0.24-4.479-0.24H59.006c-1.88,0-3.159,0.08-4.479,0.24
                    v-4.6c1.24,0.16,2.52,0.24,4.439,0.24h5.279v-9.398h-4.159c-1.88,0-3.12,0.04-4.319,0.2v-4.52c1.159,0.16,2.239,0.24,4.279,0.24
                    h4.199v-2.56c0-2.08-0.04-3.08-0.2-4.16h4.839c-0.159,0.88-0.199,1.96-0.199,4.24v2.479H73.684z"
            />
            <path
              class="st4"
              d="M89.768,112.144c0-2.08-0.08-3.36-0.24-4.6h4.6c-0.2,1.279-0.24,2.399-0.24,4.64v5.119h0.88
                    c1.479,0,2.04-0.04,2.68-0.16v4.199c-0.84-0.12-1.56-0.16-2.8-0.16h-0.76v10.878c1.56-0.72,2-0.92,3.8-1.84l0.12,4.239
                    c-3.64,1.96-5.799,2.92-9.879,4.439c-1.119,0.44-1.479,0.6-2.079,0.88l-0.84-4.599c1.199-0.16,2.359-0.521,4.759-1.44v-12.558
                    h-0.92c-1.52,0-2.159,0.04-3.119,0.2v-4.279c0.88,0.16,1.56,0.2,3.119,0.2h0.92V112.144z M104.125,137.619
                    c0,0.8,0.28,1.079,1.16,1.239c1.04,0.2,2.52,0.28,5.438,0.28c4.76,0,6.039-0.2,6.64-1.04c0.479-0.68,0.72-2.039,0.72-4.759
                    c1.279,0.56,2.999,1.079,4.359,1.319c-0.48,7.999-1.32,8.559-12.718,8.559c-8.079,0-9.839-0.76-9.839-4.279v-13.758
                    c-0.36,0.12-0.64,0.2-0.8,0.24c-1.2,0.4-1.64,0.56-2.439,0.92l-1-4.359c1.12-0.16,2.52-0.439,3.879-0.88l0.36-0.12v-5.479
                    c0-1.92-0.04-2.92-0.24-4.239h4.72c-0.16,1.279-0.24,2.439-0.24,4.079v4.359l3.88-1.24v-6.959c0-1.84-0.04-2.68-0.2-3.999h4.639
                    c-0.159,1.319-0.239,2.6-0.239,4.079v5.6l5.759-1.8c1.56-0.48,2.199-0.72,3.279-1.2c-0.08,1.76-0.12,2.04-0.2,4.199
                    c-0.2,5.64-0.479,9.278-0.88,10.998c-0.52,2.28-1.6,2.96-4.519,2.96c-0.521,0-0.88,0-1.88-0.08c-0.2-1.72-0.48-2.88-1.08-4.119
                    c0.92,0.2,1.64,0.319,2.239,0.319c1,0,1.24-0.159,1.4-0.999c0.2-1.32,0.359-3.8,0.479-7.679l-4.599,1.439v9.958
                    c0,1.64,0.08,2.76,0.239,4h-4.639c0.16-1.36,0.2-2.24,0.2-4.12v-8.479l-3.88,1.24V137.619z"
            />
          </g> -->
        </g>
        <circle class="st4" cx="61.786" cy="46.016" r="44.543" />
        <g>
          <circle class="st4" cx="61.785" cy="46.016" r="26.215" />
          <path
            class="st5"
            d="M61.786,75.232c-16.109,0-29.215-13.105-29.215-29.215s13.105-29.215,29.215-29.215S91,29.907,91,46.017
                S77.895,75.232,61.786,75.232z M61.786,22.802c-12.801,0-23.215,10.414-23.215,23.215s10.414,23.215,23.215,23.215
                S85,58.818,85,46.017S74.586,22.802,61.786,22.802z"
          />
        </g>
        <circle class="st5" cx="61.786" cy="46.016" r="8.468" />
        <g>
          <g>
            <path
              class="st5"
              d="M61.786,28.318c-1.657,0-3-1.343-3-3V12.97c0-1.657,1.343-3,3-3s3,1.343,3,3v12.349
                    C64.786,26.976,63.443,28.318,61.786,28.318z"
            />
          </g>
          <g>
            <path
              class="st5"
              d="M61.786,82.373c-1.657,0-3-1.343-3-3V68.118c0-1.657,1.343-3,3-3s3,1.343,3,3v11.255
                    C64.786,81.03,63.443,82.373,61.786,82.373z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              class="st5"
              d="M94.987,49.017H82.64c-1.657,0-3-1.343-3-3s1.343-3,3-3h12.348c1.657,0,3,1.343,3,3
                    S96.644,49.017,94.987,49.017z"
            />
          </g>
          <g>
            <path
              class="st5"
              d="M39.839,49.017H28.584c-1.657,0-3-1.343-3-3s1.343-3,3-3h11.255c1.657,0,3,1.343,3,3
                    S41.496,49.017,39.839,49.017z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {};
</script>
<style lang="scss">
.st0 {
  display: none;
}
// .st1 {
//   display: inline;
//   fill: #d2ddf0;
// }
// .st2 {
//   display: inline;
//   fill: #1e58b5;
// }
.st3 {
  enable-background: new;
}
.st4 {
  fill: #ffffff;
}
.st5 {
  fill: #1e58b5;
}
// .st6 {
//   fill: none;
//   stroke: #1e58b5;
//   stroke-width: 6;
//   stroke-linecap: round;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
// .st7 {
//   fill: #ffffff;
//   stroke: #1e58b5;
//   stroke-width: 6;
//   stroke-linecap: round;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
// .st8 {
//   fill: #1e58b5;
//   stroke: #1e58b5;
//   stroke-width: 4;
//   stroke-linecap: round;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
// .st9 {
//   fill: none;
//   stroke: #1e58b5;
//   stroke-width: 6;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
</style>